import createIcon from '../../createIcon';

/**
 * @component @name Rule
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNDUwMiAxMS4wMzUxTDEyLjkxMDIgNy40OTUwOUwxNC4zMjAyIDYuMDg1MDlMMTYuNDQwMiA4LjIwNTA5TDIwLjY4MDIgMy45NjUwOUwyMi4wOTAyIDUuMzc1MDlMMTYuNDUwMiAxMS4wMzUxWk0xMC45MTAyIDcuMDM1MDlIMS45MTAxNlY5LjAzNTA5SDEwLjkxMDJWNy4wMzUwOVpNMjAuOTEwMiAxMy40NDUxTDE5LjUwMDIgMTIuMDM1MUwxNi45MTAyIDE0LjYyNTFMMTQuMzIwMiAxMi4wMzUxTDEyLjkxMDIgMTMuNDQ1MUwxNS41MDAyIDE2LjAzNTFMMTIuOTEwMiAxOC42MjUxTDE0LjMyMDIgMjAuMDM1MUwxNi45MTAyIDE3LjQ0NTFMMTkuNTAwMiAyMC4wMzUxTDIwLjkxMDIgMTguNjI1MUwxOC4zMjAyIDE2LjAzNTFMMjAuOTEwMiAxMy40NDUxWk0xMC45MTAyIDE1LjAzNTFIMS45MTAxNlYxNy4wMzUxSDEwLjkxMDJWMTUuMDM1MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rule = createIcon('Rule', [
  [
    'path',
    {
      d: 'M16.4502 11.0351L12.9102 7.49509L14.3202 6.08509L16.4402 8.20509L20.6802 3.96509L22.0902 5.37509L16.4502 11.0351ZM10.9102 7.03509H1.91016V9.03509H10.9102V7.03509ZM20.9102 13.4451L19.5002 12.0351L16.9102 14.6251L14.3202 12.0351L12.9102 13.4451L15.5002 16.0351L12.9102 18.6251L14.3202 20.0351L16.9102 17.4451L19.5002 20.0351L20.9102 18.6251L18.3202 16.0351L20.9102 13.4451ZM10.9102 15.0351H1.91016V17.0351H10.9102V15.0351Z',
      key: '31sfab',
    },
  ],
]);

export default Rule;
